module.exports = __webpack_public_path__ + "img/wenxianLogo.641e0952.jpg";